<template>
  <a v-on:click.stop.prevent="click" class="boutonRond">
    <img :src="'/assets/icons_' + $store.state.iconTheme + '/friends.png'" />
  </a>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "FavorisButton",
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  methods: {
    click: async function() {
      const added = await idyuJsonRpc("addFriendById", this.profile.id);
      if (added == 0) {
        await alert("Ce profil a été ajouté à vos Favoris !");
        if (this.$store.state.friendList) {
          let result = {
            profile: this.profile
          };
          this.$store.state.friendList.push(result);
        }
      } else {
        await alert("Ce profil fait déjà parti de vos Favoris.");
      }
    }
  }
};
</script>

<style scoped></style>
